import React from 'react';

interface Props {
  className?: string;
  children: React.ReactNode;
}

/**
 * 사이트 공통 가로 컨테이너.
 * max-width 는 variables.apps.max-width(1480px) + gutter(20px) * 2 = 1520px.
 */
export default function Area({ className, children }: Props) {
  return (
    <div
      className={`mx-auto w-full px-gutter lg:max-w-[1520px] ${className ?? ''}`}
    >
      {children}
    </div>
  );
}
